module.exports = __webpack_public_path__ + "static/lillian-wald-mobile.00d68528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lillian-wald-mobile.jpg
// module id = 420
// module chunks = 114276838955818 164721891013254